export const checkoutUrl = 'https://colon-tranquilo-en-7-dias.impultienda.ar/checkout';
export const productImage = 'https://cdn.magicpatterns.com/uploads/heUUdY32kFeLEMRqxVKbnb/Megapack_Dopamina_Cero__Rescate_Digital-removebg-preview.png';
export const heroBadges = [{
  icon: 'file',
  label: '100% PDF'
}, {
  icon: 'zap',
  label: 'Acceso en 5 min'
}, {
  icon: 'target',
  label: 'Resultados desde el Día 2'
}];
export const trustRow = [{
  icon: 'shield',
  label: 'Garantía 7 días sin riesgo'
}, {
  icon: 'lock',
  label: 'Pago seguro'
}, {
  icon: 'card',
  label: 'Pagas en la moneda de tu país'
}];
export const heroStats = [{
  value: '+3.000',
  label: 'personas rescatadas del scroll'
}, {
  value: '6',
  label: 'tomos listos'
}, {
  value: '6',
  label: 'bonos incluidos'
}, {
  value: '4.9/5',
  label: 'calificación promedio'
}];
export const heroTestimonials = [{
  initials: 'AM',
  quote: 'Pasé de perder 3 horas en Reels a cerrar proyectos en tiempo récord. El Tomo 4 me devolvió la capacidad de concentrarme de verdad. ¡Mi productividad se duplicó!',
  author: 'Andrés M.',
  meta: 'Medellín'
}, {
  initials: 'CR',
  quote: 'Odiaba estar con mis hijos y seguir pegada al celular. Gracias al Kit SOS recuperé mi presencia y mi paz mental. Ahora el algoritmo ya no manda en mi casa.',
  author: 'Claudia R.',
  meta: 'Bogotá'
}, {
  initials: 'SV',
  quote: 'Creí que tenía TDAH, pero era solo adicción al scroll. Con el protocolo PRND mi neblina mental desapareció y volví a sacar buenas notas. ¡Espectacular!',
  author: 'Santiago V.',
  meta: 'Cali'
}, {
  initials: 'RP',
  quote: 'Ya no soy un zombie. Dejé de trasnochar viendo videos y recuperé mi energía. Duermo mejor y mi rendimiento en la oficina subió al 200%.',
  author: 'Ricardo P.',
  meta: 'Barranquilla'
}];
export const painPoints = ['Despertarte mirando redes sin siquiera querer', 'Abres TikTok por 5 minutos y pierdes 45 minutos', 'Dices "voy a leer" pero terminas viendo Reels', "Noches sin dormirte temprano porque el feed es infinito", 'Productividad en cero — tareas sin acabar', 'Relaciones superficiales — familia sin contacto real', 'Ansiedad constante por FOMO', 'Energía baja — todo parece gris', 'Culpa después de cada sesión de scroll'];
export const tomos = [{
  number: 1,
  days: 'Días 1-2',
  title: 'El Secuestro Viral',
  description: 'Entiende la ciencia. Cómo TikTok y Reels secuestran tu cerebro.',
  color: '#1F9D55'
}, {
  number: 2,
  days: 'Días 3-9',
  title: 'El Ayuno de Dopamina',
  description: '7 días de protocolo de reseteo. Sin micro-videos. Sin notificaciones.',
  color: '#2563EB'
}, {
  number: 3,
  days: 'Días 10-14',
  title: 'Arquitectura del Entorno',
  description: 'Rediseña tu espacio. Haz recaídas imposibles.',
  color: '#E2711D'
}, {
  number: 4,
  days: 'Días 15-20',
  title: 'Enfoque de Élite',
  description: 'Trabaja 5 horas sin interrupciones. Productividad real.',
  color: '#7C3AED'
}, {
  number: 5,
  days: 'Días 21-27',
  title: 'La Vida Offline',
  description: 'Reconecta con lo real. Relaciones profundas. Presencia auténtica.',
  color: '#B8860B'
}, {
  number: 6,
  days: 'Días 28-30',
  title: 'Blindaje Eterno',
  description: 'Nunca recaes. Sistema inmune digital. Control permanente.',
  color: '#DC2626'
}];
export const tomoIncludes = ['Protocolo exacto (paso por paso)', 'Scripts listos para copiar y pegar', 'Checklists de implementación', 'Registro diario de progreso', 'Respuestas a preguntas frecuentes', 'Mapeo de momentos peligrosos', 'Planes de recuperación rápida', '100% alineado a neurociencia del control digital'];
export const bonos = [{
  number: '01',
  title: 'Kit SOS Anti-Scroll',
  description: 'Tu "botón de emergencia" para cortar impulsos en menos de 5 minutos sin fuerza de voluntad.',
  value: '$24.990'
}, {
  number: '02',
  title: 'Pantallas Antirrecaída',
  description: '20 frases para tu lock screen que crean un freno mental cada vez que desbloqueas.',
  value: '$24.990'
}, {
  number: '03',
  title: 'Banco de Reemplazos de 3 Minutos',
  description: '50 acciones sin pantalla para satisfacer el aburrimiento sin caer en el algoritmo.',
  value: '$24.990'
}, {
  number: '04',
  title: 'Scripts para Desconectarte',
  description: 'Frases listas para poner límites a amigos, familia y trabajo sin sonar grosero.',
  value: '$24.990'
}, {
  number: '05',
  title: 'Menú de Micro-Recompensas Reales',
  description: 'Premia tu cerebro sin dopamina basura. Satisfacción real que dura.',
  value: '$24.990'
}, {
  number: '06',
  title: 'Tracker 72 Horas Sin Scroll',
  description: 'Tu primer reto corto para demostrar que tienes control total en solo 3 días.',
  value: '$24.990'
}];
export const bonosTotal = '$149.940';
export const moreTestimonials = [{
  initials: 'MV',
  author: 'Mónica V.',
  city: 'Bogotá',
  tag: 'MegaPack Completo',
  quote: 'El Tomo 2 fue revelador. Descubrí que mi mayor impulso era por aburrimiento, no necesidad. Ahora trabajo 5 horas sin interrupciones.'
}, {
  initials: 'DL',
  author: 'Diego L.',
  city: 'Barranquilla',
  tag: 'Trabajador de Oficina',
  quote: 'El Banco de Reemplazos (Bono 3) me salvó. Cuando quiero scroll, abro la lista. 90% de las veces hago otra cosa y el impulso desaparece.'
}, {
  initials: 'AC',
  author: 'Adriana C.',
  city: 'Cali',
  tag: 'MegaPack + Plan Bonus',
  quote: 'Día 30 y no extraño el scroll. Siento como si tuviera mi vida de vuelta. Mi familia dice que me extrañaba.'
}, {
  initials: 'RF',
  author: 'Roberto F.',
  city: 'Medellín',
  tag: 'Ejecutivo',
  quote: 'No creía que iba a durar. Pero el protocolo es tan claro y fácil de aplicar que se vuelve una solución rápida. Lo recomendé a 5 amigos.'
}];
export const faqs = [{
  question: '¿Sirve para todos los niveles de adicción?',
  answer: 'Sí. El Protocolo PRND está diseñado para cualquier nivel de dependencia: desde scroll casual hasta adicción severa. Los bonos te ayudan a identificar TU patrón específico y adaptar el sistema.'
}, {
  question: '¿Cómo recibo el material?',
  answer: '100% digital. En 5 minutos después de compra recibes un enlace con todos los PDFs (6 tomos + 6 bonos). Los descargas una sola vez o accedes desde cualquier dispositivo. Sin restricciones.'
}, {
  question: '¿Es compatible con un trabajo o estudio que requiere internet?',
  answer: 'Totalmente. El sistema enseña a usar el celular CON INTENCIÓN, no a eliminarlo. Trabajas, estudias y usas redes productivas. Solo controlas el scroll basura y las distracciones compulsivas.'
}, {
  question: '¿Qué pasa si recaigo?',
  answer: 'El Tomo 6 (Blindaje Eterno) y el Bono 1 (Kit SOS) te enseñan exactamente qué hacer. Una recaída NO cancela tu progreso. Es datos para mejorar. 90% de usuarios que "recaen" vuelven en menos de 10 minutos.'
}, {
  question: '¿Necesito comprar apps o suscripciones extra?',
  answer: 'No. Todo lo necesario está en los PDFs. Algunos bonos mencionan apps gratuitas, pero es 100% opcional. El sistema funciona con lo que ya tienes: celular, libreta, lápiz.'
}, {
  question: '¿Cuánto tiempo me toma aplicar el sistema?',
  answer: 'Día 1: 30 minutos de lectura. Días 2-30: 5-10 minutos diarios de implementación. Está diseñado para ser accionable, no teórico. Mientras más lo apliques, más rápido ves resultados.'
}];
export const costWithout = ['Pegado 6+ horas al celular diario', 'Trabajo sin completar', 'Relaciones superficiales', 'Sueño de mala calidad', 'Ansiedad constante', 'Productividad en cero', 'Culpa diaria', 'Mismo ciclo el próximo año'];
export const costWith = ['Tiempo en pantalla controlado', '5+ horas de trabajo profundo', 'Conexiones reales y presentes', 'Sueño profundo y reparador', 'Calma y tranquilidad mental', 'Productividad real', 'Orgullo de ti mismo', 'Vida libre del algoritmo'];
export const pricing = {
  original: '$108.000',
  current: '$38.990',
  currency: 'COP',
  increase: 'a $97.000 COP',
  claimedPercent: 78
};
export const paymentMethods = 'Bancolombia | Nequi | Tarjeta de crédito';
export const contact = {
  email: 'soportiendapdf@gmail.com',
  instagram: '@habil_online'
};